/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const UPDATE_FEEDBACK = gql`
    mutation (
        $name: String!
        $email: String!
        $birthDate: String!
        $telephone: String
        $anniversaryDate: String
        $barcodeHash: String
        $comments: String
        $rating: Int!
        $nfcHash: String
        $latitude: Float
        $longitude: Float
        $v2Batch: String
    ) {
        createContestEntryWeb(
            name: $name
            email: $email
            birthDate: $birthDate
            telephone: $telephone
            anniversaryDate: $anniversaryDate
            barcodeHash: $barcodeHash
            comments: $comments
            rating: $rating
            nfcHash: $nfcHash
            latitude: $latitude
            longitude: $longitude
            v2Batch: $v2Batch
        )
    }
`;
